import React from 'react';
import Helmet from 'react-helmet';
import Waypoint from 'react-waypoint';
import Raven from 'raven-js';

import Versions from 'api/resources/versions';
import getErrors from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';
import fullname from 'utils/fullname';

import AuditRow from 'components/AuditRow';
import Loader from 'components/Loader';
import AuditForm from 'components/AuditForm';

import Main from 'styled/Page/Main';
import RightColumn from 'styled/Page/RightColumn';
import Header from 'styled/Page/Header';
import HeaderTitle from 'styled/Page/HeaderTitle';
import CenteredContainer from 'styled/Page/CenteredContainer';
import ErrorText from 'styled/Page/ErrorText';

import AuditListWrapper from './AuditListWrapper';

const PAGE_SIZE = 5;

class AuditPage extends React.PureComponent {
  state = {
    loading: false,
    errors: [],
    versions: [],
    pageNumber: 0,
    hasMore: false,
  }

  componentDidMount() {
    this.loadVersions();
  }

  handleAuditFormSubmit = (data) => {
    this.setState({ ...data }, this.reloadVersions);
  }

  reloadVersions = async () => {
    window.scrollTo(0, 0);

    this.setState({
      pageNumber: 0,
      versions: [],
    }, this.loadVersions);
  }

  loadVersions = async () => {
    this.setState({ loading: true });

    try {
      const response = await Versions.getAll({
        page: {
          number: this.state.pageNumber,
          size: PAGE_SIZE,
        },
        filter: {
          start_date: this.state.startDate ? Number(new Date(this.state.startDate)) / 1000 : undefined,
          end_date: this.state.endDate ? Number(new Date(this.state.endDate)) / 1000 : undefined,
          item_id: this.state.itemId || undefined,
          item_type: this.state.itemType === 'all' ? undefined : this.state.itemType,
          event: this.state.event === 'all' ? undefined : this.state.event,
          employee_id: this.state.employee
            && this.state.employee.value
            && this.state.employee.value !== 'all'
            ? this.state.employee.value
            : undefined,
        },
        include: 'employee,employee.avatar',
      });

      const versions = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState(prevState => ({
        versions: prevState.versions.concat(versions),
        loading: false,
        hasMore: versions.length === PAGE_SIZE,
        pageNumber: prevState.pageNumber + 1,
      }));
    } catch (err) {
      this.setState({ errors: await getErrors(err), loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <Main>
        <Helmet><title>Журнал изменений</title></Helmet>

        <AuditListWrapper>
          <Header>
            <HeaderTitle>Журнал изменений</HeaderTitle>
          </Header>

          {this.state.versions.map(item => (
            <AuditRow
              key={item.id}
              id={item.id}
              employeeFullname={fullname(item.employee)}
              employeeAvatar={item.employee && item.employee.avatar && item.employee.avatar.url}
              employeeRoles={item.employee && item.employee.roles}
              employeeIp={item.ip}
              employeeUserAgent={item.userAgent}
              event={item.event}
              itemId={item.itemId}
              createdAt={item.createdAt}
              objectChanges={item.objectChanges}
              itemType={item.itemType}
            />
          ))}

          {!this.state.loading && !this.state.errors.length && !this.state.versions.length && (
            <CenteredContainer>Список изменений пуст</CenteredContainer>
          )}

          {this.state.loading && <CenteredContainer><Loader /></CenteredContainer>}

          {!this.state.loading && !this.state.errors.length && this.state.hasMore &&
            <Waypoint onEnter={this.loadVersions} />
          }

          {this.state.errors.length > 0 && (
            <CenteredContainer>
              {this.state.errors.map(error => (
                <ErrorText role="alert" key={error}>{error}</ErrorText>
              ))}
            </CenteredContainer>
          )}
        </AuditListWrapper>

        <RightColumn>
          <AuditForm onSubmit={this.handleAuditFormSubmit} loading={this.state.loading} />
        </RightColumn>
      </Main>
    );
  }
}

export default AuditPage;
